<div [formGroup]="myGroup" class="array-html-element-container">
    <!-- Selector de item existente -->
    <div class="item-selector-row">
        <mat-form-field appearance="outline" class="selector-field">
            <mat-label>{{name}}</mat-label>
            <mat-select placeholder="Seleccionar item para editar" formControlName="customElement" name="customElement">
                <mat-option value="">--- Seleccionar ---</mat-option>
                <mat-option *ngFor="let item of value; let i = index" [value]="i" (click)="choosenElement(item.value)">
                    {{ getItemDisplayName(item, i) }}
                </mat-option>
            </mat-select>
            <mat-hint>Selecciona un item para editarlo o eliminarlo</mat-hint>
        </mat-form-field>

        <button
            mat-icon-button
            color="warn"
            class="remove-button"
            [matTooltip]="'Eliminar item seleccionado'"
            [disabled]="!myGroup.get('customElement').value && myGroup.get('customElement').value !== 0"
            (click)="removerItem()"
        >
            <mat-icon>delete</mat-icon>
        </button>
    </div>

    <!-- Formulario para agregar nuevo item -->
    <div class="add-item-section">
        <div class="section-header">
            <mat-icon>add_circle</mat-icon>
            <span>Agregar nuevo item</span>
        </div>
        <div class="add-item-form">
            <mat-form-field appearance="outline" class="nombre-field">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="customElementNombre" placeholder="Ej: Opción 1" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="valor-field">
                <mat-label>Valor</mat-label>
                <input matInput formControlName="customElementValue" placeholder="Ej: valor1" />
            </mat-form-field>

            <button
                mat-raised-button
                color="primary"
                class="add-button"
                [matTooltip]="'Agregar item a la lista'"
                [disabled]="!myGroup.get('customElementNombre').value || !myGroup.get('customElementValue').value"
                (click)="anadirItem()"
            >
                <mat-icon>add</mat-icon>
                <span>Agregar</span>
            </button>
        </div>
    </div>

    <!-- Lista de items existentes -->
    <div class="items-list" *ngIf="value && value.length > 0">
        <div class="list-header">
            <mat-icon>list</mat-icon>
            <span>Items configurados ({{value.length}})</span>
        </div>
        <div class="items-container">
            <div *ngFor="let item of value; let i = index" class="item-row">
                <mat-icon class="item-icon">radio_button_checked</mat-icon>
                <div class="item-content">
                    <div class="item-title">{{ getItemDisplayName(item, i) }}</div>
                    <div class="item-nombre-hint" *ngIf="item.nombre && item.value !== item.nombre" [matTooltip]="'Clave: ' + item.nombre">{{ item.nombre }}</div>
                </div>
                <button mat-icon-button color="warn" class="delete-button" (click)="removerItemByIndex(i)" matTooltip="Eliminar item">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Mensaje cuando no hay items -->
    <div class="empty-state" *ngIf="!value || value.length === 0">
        <mat-icon>info</mat-icon>
        <p>No hay items configurados. Agrega uno usando el formulario de arriba.</p>
    </div>
</div>
